import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../client';

function unwrapApiResponse(data: any): any {
  if (data && typeof data === 'object' && 'success' in data && 'data' in data) {
    return data.data;
  }
  return data;
}

export const useCompanies = (workspaceId = '') => {
  return useQuery({
    queryKey: ['companies', workspaceId],
    queryFn: () => client.get('/companies', { params: { workspaceId } }).then(r => r.data).then(unwrapApiResponse),
    enabled: !!workspaceId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCompany = (id: string, workspaceId: string) => {
  return useQuery({
    queryKey: ['company', id, workspaceId],
    queryFn: () => client.get(`/companies/${id}`, { params: { workspaceId } }).then(r => r.data).then(unwrapApiResponse),
    enabled: !!id && !!workspaceId,
  });
};

export const useCreateCompany = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post('/companies', data).then(r => r.data),
    onSuccess: (_data, vars: any) => {
      qc.invalidateQueries({ queryKey: ['companies', vars.workspaceId] });
    },
  });
};

export const useUpdateCompany = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: any) => client.put(`/companies/${id}`, data).then(r => r.data),
    onSuccess: (_data, vars: any) => {
      qc.invalidateQueries({ queryKey: ['companies', vars.workspaceId] });
      qc.invalidateQueries({ queryKey: ['company', vars.id] });
    },
  });
};

export const useDeleteCompany = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => client.delete(`/companies/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['companies'] });
    },
  });
};
